import { useState } from "react";
import { ShieldAlert, PhoneCall } from "lucide-react";
import Sidebar from "../../../components/ui/sidebar";
import { SOSAsuntosModal } from "./SOSAsuntosModal";
import { SOSTelefonosModal } from "./SOSTelefonosModal";

export default function ConfigurarSOSPage() {
  const [activeModal, setActiveModal] = useState<"asuntos" | "telefonos" | null>(null);

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300 text-gray-900">
      <Sidebar />

      <main className="flex-1 p-4 sm:p-6 md:ml-64 transition-all">
        <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6 text-military-600 flex items-center gap-2">
          <ShieldAlert className="text-red-500 w-8 h-8" />
          Configurar SOS
        </h2>

        <div className="bg-white rounded-xl shadow-xl border-l-4 border-red-500 p-6 sm:p-8">
          <p className="text-gray-600 text-base text-center mb-8">
            Seleccione la opción que desea configurar para las alertas de emergencia SOS.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-3xl mx-auto">
            <button
              onClick={() => setActiveModal("asuntos")}
              className="flex flex-col items-center justify-center gap-4 p-8 bg-red-50 hover:bg-red-100 border border-red-200 rounded-xl transition-all shadow-sm"
            >
              <div className="bg-red-500 p-4 rounded-full text-white shadow-md">
                <ShieldAlert size={40} />
              </div>
              <span className="font-semibold text-gray-800 text-xl">Asuntos</span>
              <span className="text-sm text-gray-500 text-center">
                Tipos de emergencias reportables
              </span>
            </button>

            <button
              onClick={() => setActiveModal("telefonos")}
              className="flex flex-col items-center justify-center gap-4 p-8 bg-blue-50 hover:bg-blue-100 border border-blue-200 rounded-xl transition-all shadow-sm"
            >
              <div className="bg-blue-500 p-4 rounded-full text-white shadow-md">
                <PhoneCall size={40} />
              </div>
              <span className="font-semibold text-gray-800 text-xl">Teléfonos</span>
              <span className="text-sm text-gray-500 text-center">
                Contactos a notificar
              </span>
            </button>
          </div>
        </div>
      </main>

      {/* Sub Modals */}
      <SOSAsuntosModal
        isOpen={activeModal === "asuntos"}
        onClose={() => setActiveModal(null)}
      />
      <SOSTelefonosModal
        isOpen={activeModal === "telefonos"}
        onClose={() => setActiveModal(null)}
      />
    </div>
  );
}
